module.exports = __webpack_public_path__ + "images/background/image_thumbnail/4-off-3ec592dc53b15f5fd9c05c968ba86b3a.jpg";